import { utils } from '../utils';
import { HttpClient } from '@wix/http-client';
import { serverItemsToProGallery } from '@wix/pro-gallery-items-formatter';
import { Wix, Consts } from '@wix/photography-client-lib';
var httpClient = new HttpClient();
var fetchItems = function (fromItem) {
    var storeParameter = '';
    if (utils.isStoreGallery()) {
        storeParameter = "&isStore=true";
    }
    var toItem = fromItem + 100;
    // artStore works only with OLD server APIs
    var shouldUseNewApis = !utils.isStoreGallery(); // ARTSTORE does not work with new apis
    if (shouldUseNewApis) {
        // ------------ New Server APIs ---------------- //
        if (utils.isVerbose()) {
            console.log('API REFACTOR - items Helper using New APIs to fetch items');
        }
        var state = Wix.Utils.getDemoMode()
            ? Consts.dataSavedState.PUBLISHED
            : Consts.dataSavedState.SAVED;
        var url = "https://progallery.wixapps.net/v1/galleries/".concat(window.galleryId, "?offset=").concat(fromItem, "&limit=100&state=").concat(state);
        return httpClient
            .request({
            url: url,
            method: 'GET',
            headers: {
                // 'x-wix-linguist': getMultiLangHeader(),
                Authorization: window.instance,
            },
        })
            .then(function (res) { return res.data; })
            .then(function (data) { return (data ? serverItemsToProGallery(data.gallery.items) : []); })
            .catch(function (e) {
            console.error('Cannot fetch items from new server', e);
            return [];
        });
    }
    else {
        // ------------ Old Server APIs ---------------- //
        var url = "".concat(window.infiniteScrollUrl, "from/").concat(fromItem, "/to/").concat(toItem + 1, "?instance=").concat(window.instance).concat(storeParameter);
        return httpClient
            .request({
            url: url,
            method: 'GET',
            withCredentials: true,
            xsrfCookieName: null,
            disableWixHeaders: true,
        })
            .then(function (res) { return res.data; })
            .then(function (data) { return (data ? data.items : []); })
            .catch(function (e) {
            console.error('Cannot fetch items from server', e);
            return [];
        });
    }
};
function formatServerGalleryResponse(serverGalleryResponseData) {
    var gallery = serverGalleryResponseData && serverGalleryResponseData.gallery;
    return !!gallery
        ? {
            dateCreated: gallery.created,
            galleryId: gallery.id,
            pageResponse: {
                totalItemsCount: gallery.totalItemsCount,
                items: serverItemsToProGallery(gallery.items),
            },
        }
        : {};
}
var fetchData = function (fromItem, calledFrom) {
    var state = Wix.Utils.getDemoMode()
        ? Consts.dataSavedState.PUBLISHED
        : Consts.dataSavedState.SAVED;
    var url = "https://progallery.wixapps.net/v1/galleries/".concat(window.galleryId, "?offset=").concat(fromItem, "&limit=100&state=").concat(state);
    return httpClient
        .request({
        url: url,
        method: 'GET',
        headers: {
            Authorization: window.instance,
        },
    })
        .then(function (res) { return res.data; })
        .then(function (data) { return formatServerGalleryResponse(data); })
        .catch(function (e) {
        console.error('Cannot fetch data from new server, ProGalleryTpaWrapper' +
            '\n' +
            'url: ' +
            url +
            '\n' +
            'calledFrom: ' +
            calledFrom +
            '\n' +
            'error: ' +
            e);
        return {};
    });
};
function getMultiLangFields() {
    var lang = window.lang, isPrimaryLanguage = window.isPrimaryLanguage, dateNumberFormat = window.dateNumberFormat;
    if (lang) {
        return {
            isPrimaryLanguage: isPrimaryLanguage,
            lang: lang,
            dateNumberFormat: dateNumberFormat,
        };
    }
    return null;
}
function getMultiLangHeader() {
    var fields = getMultiLangFields();
    var instanceId = window.instanceId;
    return fields
        ? "".concat(fields.lang, "|").concat(fields.dateNumberFormat, "|").concat(fields.isPrimaryLanguage, "|").concat(instanceId)
        : '';
}
var alreadyGettingItems = false;
function getItemsFromDb(fromItem) {
    if (alreadyGettingItems === true) {
        return new Promise.resolve([]);
    }
    else {
        alreadyGettingItems = true;
        return fetchItems(fromItem).then(function (items) {
            alreadyGettingItems = false;
            return items;
        });
    }
}
function getGalleryDataFromDB(fromItem, calledFrom) {
    return fetchData(fromItem, calledFrom).then(function (data) {
        return data;
    });
}
export { getItemsFromDb, getGalleryDataFromDB };
//# sourceMappingURL=itemsHelper.js.map